export default __webpack_public_path__ + "static/media/model.f86ecb77.png";